module.exports = __webpack_public_path__ + "static/media/Growing_Pains.9a20e5b7.md";